import { DatePipe, DecimalPipe, NgClass, NgFor, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { AccountService } from '../../../../Services/Accounts/account.service';

@Component({
  selector: 'app-expense',
  standalone: true,
  imports: [NgIf, NgFor, NgClass, DecimalPipe, DatePipe],
  templateUrl: './expense.component.html',
  styleUrl: './expense.component.css'
})
export class ExpenseComponent implements OnChanges {
  @Input() firmId: any;
  @Input() isGst: boolean = true;
  @Input() fromDate: string = '';
  @Input() toDate: string = '';
  @Output() balancesLoaded = new EventEmitter<any[]>();

  isLoading = false;
  transactions: any[] = [];
  summary = {
    amount_in: { cash: 0, bank: 0, card: 0, online: 0, disc: 0, total: 0 },
    amount_out: { cash: 0, bank: 0, card: 0, online: 0, disc: 0, total: 0 },
    opening_balance: 0,
    closing_balance: 0
  };

  expenseSummary = {
    title: 'Expense Details',
    total: 0,
  };

  // accordion
  accordionState = {
    expense: false,
  };

  constructor(private accountService: AccountService) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['firmId'] || changes['fromDate'] || changes['toDate']) {
      this.loadExpenseData();
    }
  }

  loadExpenseData() {
    this.isLoading = true;
    const params = {
      firm_id: this.firmId,
      from_date: this.fromDate,
      to_date: this.toDate
    };

    this.accountService.getDaybookCashflow(params).subscribe({
      next: (res: any) => {
        this.transactions = res.data.expense_transactions || [];
        this.calculateSummary();
        this.expenseSummary.total = this.transactions.reduce((sum, t) => sum + Math.abs(t.total), 0);
        this.balancesLoaded.emit(res.data.account_balances || []);
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error loading expense data', err);
        this.isLoading = false;
      }
    });
  }
  // Added the method to show the summary of the expense data expected in form of in and out and the opening and closing balance.
  // Added by Pratik 24 June 2026
  calculateSummary() {
    this.summary = {
      amount_in: { cash: 0, bank: 0, card: 0, online: 0, disc: 0, total: 0 },
      amount_out: { cash: 0, bank: 0, card: 0, online: 0, disc: 0, total: 0 },
      opening_balance: 0,
      closing_balance: 0
    };

    this.transactions.forEach(t => {
      const cash = Number(t.cash || 0);
      const bank = Number(t.bank || 0);
      const card = Number(t.card || 0);
      const online = Number(t.online || 0);
      const disc = Number(t.disc || 0);

      // Amount In
      if (cash > 0) this.summary.amount_in.cash += cash;
      if (bank > 0) this.summary.amount_in.bank += bank;
      if (card > 0) this.summary.amount_in.card += card;
      if (online > 0) this.summary.amount_in.online += online;
      if (disc > 0) this.summary.amount_in.disc += disc;

      // Amount Out
      if (cash < 0) this.summary.amount_out.cash += Math.abs(cash);
      if (bank < 0) this.summary.amount_out.bank += Math.abs(bank);
      if (card < 0) this.summary.amount_out.card += Math.abs(card);
      if (online < 0) this.summary.amount_out.online += Math.abs(online);
      if (disc < 0) this.summary.amount_out.disc += Math.abs(disc);
    });

    this.summary.amount_in.total = this.summary.amount_in.cash + this.summary.amount_in.bank + this.summary.amount_in.card + this.summary.amount_in.online;
    this.summary.amount_out.total = this.summary.amount_out.cash + this.summary.amount_out.bank + this.summary.amount_out.card + this.summary.amount_out.online;

    this.summary.opening_balance = 0;
    this.summary.closing_balance = this.summary.opening_balance + (this.summary.amount_in.total - this.summary.amount_out.total);
  }

  toggleAccordion(type: 'expense') {
    this.accordionState[type] = !this.accordionState[type];
  }
}
